// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"138":"04c94ece","630":"ed54b502","667":"c72e8b2a","942":"6de50642"}[chunkId] + ".css";
};